import * as React from 'react'
import { Config } from '@chegg-wt/core/config'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state/types'
import { AppRoute } from '@chegg-wt/core/types/core'
import { DashboardUpsellCopy } from '@chegg-wt/core/types/features'
import {
  routeToHref,
  addQueryStringToRoute,
  addRedirectQueryToRoute,
} from '@chegg-wt/core/utils/routes'
import { loggedInSelector } from '@chegg-wt/core/state/user/selectors'
import AppLink from '../AppLink'
import { useRoutesContext } from '../RoutesContext'
import TermsAndConditionsLink from '../TermsAndConditionsLink'
import {
  CITATION_UPSELL,
  CITATION_UPSELL_ITEM,
  CITATION_CTA,
  TC_LINK,
  CITATION_UPSELL_HEADING,
  CITATION_UPSELL_SUB_HEADING,
} from './utils/testIds'
import {
  PanelContainer,
  PanelCTAHeading,
  PanelSubHeading,
  CitationsCTAButton,
  TermsWrapper,
  SignInLink,
  SignInWrapper,
  FeatureListContainer,
} from './styles'
import { FeatureItem } from './common'

interface CitationsCTAPanelProps {
  redirectTo: AppRoute
  upsellCopy: DashboardUpsellCopy
  onClickCTA: () => void
  loggedIn: boolean
  hideTermsAndConditions?: boolean
}

const CitationsCTAPanel: React.FC<CitationsCTAPanelProps> = ({
  redirectTo,
  loggedIn,
  onClickCTA,
  upsellCopy,
  hideTermsAndConditions = false,
}) => {
  const { toUpgrade } = useRoutesContext()
  const redirectUrl = routeToHref(redirectTo)

  const upgradeSignUpRoute = addRedirectQueryToRoute(toUpgrade(), redirectUrl)

  const upgradeSignInRoute = addQueryStringToRoute(
    addRedirectQueryToRoute(toUpgrade(), redirectUrl),
    {
      signIn: 'true',
    }
  )

  const {
    FEATURE_LIST,
    UPSELL_HEADING,
    UPSELL_SUBHEADING,
    CTA_COPY,
  } = upsellCopy.citationsCTA

  const features = FEATURE_LIST.map((text, index) => (
    <FeatureItem
      key={text}
      featureText={text}
      testId={`${CITATION_UPSELL_ITEM}_${index}`}
    />
  ))
  const handleCTAClick = () => {
    onClickCTA()
  }
  return (
    <PanelContainer data-test={CITATION_UPSELL}>
      <PanelCTAHeading data-test={CITATION_UPSELL_HEADING}>
        {UPSELL_HEADING}
      </PanelCTAHeading>
      <PanelSubHeading data-test={CITATION_UPSELL_SUB_HEADING}>
        {UPSELL_SUBHEADING}
      </PanelSubHeading>
      <FeatureListContainer>{features}</FeatureListContainer>
      <AppLink route={upgradeSignUpRoute}>
        <CitationsCTAButton
          onClick={handleCTAClick}
          data-test={CITATION_CTA}
          aria-label={CTA_COPY}
        >
          {CTA_COPY}
        </CitationsCTAButton>
      </AppLink>
      {!hideTermsAndConditions && (
        <TermsWrapper>
          <TermsAndConditionsLink
            href={Config.trialTermsAndConditionsUrl}
            testId={TC_LINK}
          />
        </TermsWrapper>
      )}
      {!loggedIn && (
        <SignInWrapper>
          Already have an account?&nbsp;
          <AppLink route={upgradeSignInRoute}>
            <SignInLink aria-label="Sign in to citations">Sign in</SignInLink>
          </AppLink>
        </SignInWrapper>
      )}
    </PanelContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  loggedIn: loggedInSelector(state),
})

export default connect(mapStateToProps)(CitationsCTAPanel)
